/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `SETUP` - Setup
 * * `MISSING_INFO` - Missing Info
 * * `PROVIDER_PROFILE` - Provider Profile
 * * `PROVISIONAL` - Provisional
 * * `COMPLETE` - Complete
 * * `REJECTED` - Rejected
 */
export enum RegistrationStatusEnum {
    SETUP = 'SETUP',
    MISSING_INFO = 'MISSING_INFO',
    PROVIDER_PROFILE = 'PROVIDER_PROFILE',
    PROVISIONAL = 'PROVISIONAL',
    COMPLETE = 'COMPLETE',
    REJECTED = 'REJECTED',
}
